export default __webpack_public_path__ + "static/media/clip.9f239450.jpeg";